module.exports = __webpack_public_path__ + "static/ses-2021-apr-c8419ff5cba7891e9edce54db3f23e83.pdf";